/**
 * This function returns random number in range `0 <= number < max`
 * @param max max number
 * @returns random number in range `0 <= number < max`
 */
export const getRandomInt = (max: number): number => {
    return Math.floor(Math.random() * max);
};

/**
 * This function returns random number in range `min <= number < max`
 * @param max max number
 * @param min min number
 * @returns random number in range `min <= number < max`
 */
export const getRandomIntInRange = (max: number, min: number) => {
    if (min > max) return -1;
    return Math.max(min, getRandomInt(max));
};
